module.exports = __webpack_public_path__ + "static/media/logo-doods.bc59fa28.svg";